require("../app/page_switch.coffee")

$(document).ready ->
  new window.PageSwitch()

$(document).on 'page:load', ->
  new window.PageSwitch()


// WEBPACK FOOTER //
// ./assets/javascripts/pages/catalog.coffee